export default __webpack_public_path__ + "static/media/article_3.081849b2.jpg";